/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */

import React from 'react';
import { HStack, Separator } from 'chakra-v3';
import { Text } from '../Text';

const HelpOrDivider: React.FC = () => (
  <HStack gap={3} w="100%" alignItems="center" justifyContent="center" h="22px">
    <Separator orientation="horizontal" flex={1} color="separator.tealGradient1" />
    <Text variant="body" fontSize="16px" fontWeight="600" color="brand.grey" letterSpacing="0.08px" whiteSpace="nowrap">
      OR
    </Text>
    <Separator orientation="horizontal" flex={1} color="separator.tealGradient1" />
  </HStack>
);

export default HelpOrDivider;
